import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-field',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './form-field.html',
})
export class FormField {
  @Input() label!: string;
  @Input({ required: true }) control!: FormControl<unknown>;
  @Input() placeholder = '';
  @Input() type: 'text' | 'email' | 'tel' = 'text';

  isFieldInvalid(): boolean {
    return !!(
      this.control &&
      this.control.invalid &&
      (this.control.dirty || this.control.touched)
    );
  }
}
